import { render, staticRenderFns } from "./NotificationFilter.vue?vue&type=template&id=0b4e0ef0&"
import script from "./NotificationFilter.vue?vue&type=script&lang=js&"
export * from "./NotificationFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports